export default "__VITE_ASSET__BQCX8FU4__"